import Image from "next/image";
import React from "react";
import styles from "./pubad-optional.module.css";
import Carousel from 'react-bootstrap/Carousel';
import Crashcourse from "../../assets/images/home/Moksha/PubAd/PubAd-Web-Banner.jpg";
import Mobcrashcourse from "../../assets/images/home/Moksha/PubAd/PubAd-Mobile-Banner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import Link from "next/link";
import Head from "next/head";

const UPSC_Main_Test_Series_2023 = () => {
    const BGimg = [
        // { img: carouselBGimg4, alt: "carousel", link: "/" },
        // { img: carouselBGimg3, alt: "carousel", link: "/upsc-mains-test-series" }
    ]
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title> UPSC  Mathematics  Mains Test Series 2026</title>
            <meta name="title" content=" UPSC  Mathematics Mains Test Series 2026" />
            <meta name="description" content="Join UPSC Mathematics  Mains Test Series 2026 by Shankar IAS Academy. Get expert feedback, model answers & boost your writing skills." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-mathematics-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content=" UPSC  Mathematics Mains Test Series 2026" />
            <meta property="og:description" content="Join UPSC Mathematics  Mains Test Series 2026 by Shankar IAS Academy. Get expert feedback, model answers & boost your writing skills." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-mathematics-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>


        <Navbar title="upsc" />

<div className="container">
    <div className="row">
        <div className="col pt-3 pt-md-4">
          <h1 className={`${styles.pagemaintitle}`}>UPSC Mathematics Mains Test Series 2026</h1>
        </div>
    </div>
    {/* <div className="row d-none d-md-block">
        <div className="col mb-3">
             <Image
                src={Crashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
        </div>
    </div> */}
    {/* <div className="row d-block d-md-none">
        <div className="col mb-3">
              <Image
                src={Mobcrashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
        </div>
   </div>  */}
</div> 

<div className="container py-4">
           <div className={styles.customTable}>
                <div className={`${styles.tableRow} ${styles.tableHead}`}>
                        <div className={styles.tableCol}>Batch</div>
                        <div className={styles.tableCol}>Starts On</div>
                        <div className={styles.tableCol}>Mode</div>
                        <div className={styles.tableCol}>Fee</div>
                        <div className={styles.tableCol}>Schedule</div>
                        <div className={styles.tableCol}>Payment</div>
                </div>

                <div className={`${styles.tableRow} ${styles.tableBody}`}>
                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Batch</span>
                                <p className={`${styles.batchName} mb-0`}>
                                BATCH - I
                                </p>
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Starts On</span>
                                <p className={`${styles.normalText} mb-0`}>
                                08.06.2026
                                </p>
                        </div>

                        <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Mode</span>
                                <p className={`${styles.normalText} mb-0`}>
                                        Online / Offline
                                </p>
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Fee</span>
                                <p className={`${styles.normalText} mb-0`}>
                                 ₹5,000 
                                </p>
                                
                                
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Schedule</span>
                                <a
                                        
                                        href="https://shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Maths/Maths-B1-2026.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.pdfBtn}
                                        >
                                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                                        Click Here
                                </a>
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Payment</span>
                                <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Pay Now</a></span>
                        </div>
                </div>

                <div className={`${styles.tableRow} ${styles.tableBody}`}>
                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Batch</span>
                                <p className={`${styles.batchName} mb-0`}>
                                BATCH - II
                                </p>
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Starts On</span>
                                <p className={`${styles.normalText} mb-0`}>
                                   01.08.2026
                                </p>
                        </div>

                        <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Mode</span>
                                <p className={`${styles.normalText} mb-0`}>
                                        Online / Offline
                                </p>
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Fee</span>
                                <p className={`${styles.normalText} mb-0`}>
                                 ₹10,000 
                                </p>
                                
                                
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Schedule</span>
                                <a
                                        
                                        href="https://shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Maths/Maths-B2-2026.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.pdfBtn}
                                        >
                                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                                        Click Here
                                </a>
                        </div>

                        <div className={styles.tableCol}>
                                <span className={styles.mobileLabel}>Payment</span>
                                <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Pay Now</a></span>
                        </div>
                </div>

                
           </div>
        </div>


                    
          
            <Footer />
        </>
    )
}
export default UPSC_Main_Test_Series_2023;
